export default (items) => items.map((item) => ({ text: item, key: item }))
